import axios from 'axios';
const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const addAddress = (data: any) => {
    return axios.post(`${API_URL}address/addAddress`, data);
}

const getAddress = (id: string) => {
    return axios.get(`${API_URL}address/${id}`);
}

const verifyPostalCode = (postalCode: string) => {
    return axios.get(`${API_URL}address/verifyPostal?postalCode=${postalCode}`);
}

export const APIDA = {
    addAddress,
    getAddress,
    verifyPostalCode
}